export class PaginatorData {
  pageSize: number;
  pageIndex: number;
}
